export default __webpack_public_path__ + "files/btn_arrow_r_nomal.png";